// ─── src/data/uae/country.js ────────────────────────────────────────────────
// UAE country entity. Destination slug "uae"; primary market is Dubai.

export const UAE_COUNTRY = {
  id: "uae",
  slug: "uae",
  name: "UAE",
  iso2: "AE",
  listingCount: 0,
  canonicalRoute: "/uae",
  seoTitleTemplate: "Luxury Wedding Venues in the UAE | LWD",
  metaDescriptionTemplate: "Discover curated luxury wedding venues and vendors across the UAE. Dubai palace celebrations, Abu Dhabi cultural grandeur, and desert ceremonies, editorially selected.",
  evergreenContent: "The UAE has built one of the world's most extraordinary luxury wedding markets in a single generation. Dubai's ambition, private islands, Burj-view terraces, desert palaces, sits alongside Abu Dhabi's cultural refinement and Ras Al Khaimah's mountain landscapes. No other destination in the world concentrates this density of ultra-luxury production within a single city.",
  focusKeywords: [
    "luxury wedding uae",
    "dubai wedding venues",
    "abu dhabi wedding",
    "destination wedding dubai",
    "palace wedding dubai",
  ],
  aiSummary: "Ultra-luxury destination market. Dubai dominates with palace weddings, desert glamour, and world-class production. Abu Dhabi rising as cultural alternative. Peak season November to April.",
  intentSignals: {
    high: ["dubai wedding venue book", "luxury wedding dubai cost", "palace wedding dubai hire"],
    mid: ["best wedding venues dubai", "dubai destination wedding ideas", "abu dhabi wedding guide"],
    low: ["getting married in dubai", "dubai wedding traditions", "uae wedding inspiration"],
  },
  entityAliases: ["United Arab Emirates", "Emirates"],
};
